// extracted by mini-css-extract-plugin
export default {"root_scroller":"HM","flex_container":"IM","container":"JM","scroller":"KM","indicator":"LM","scrollButtons":"MM","selected":"NM","root_tab":"OM","root_tab_scrollable":"PM","root_scroller_mob":"QM","scroller_mob":"RM","indicator_mob":"SM","selected_mob":"TM","root_tab_mob":"UM","root_tab_mob_scrollable":"VM"};
    if(module.hot) {
      // 1711717533901
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  